import {
  Box,
  Button,
  Container,
  Grid,
  GridItem,
  Image,
  Text,
} from "@chakra-ui/react";
import RightArrowUp from "common/assets/img/arrowRightUp.png";
import { landingPageConstants } from "common/landingPageConstants";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";
import UserImg from "common/assets/img/dummyTesti.png";
import VidSecBg from "common/assets/img/vidSecBg.png";
import ArrowRight from "common/assets/img/arrowRightWhite.png";


const mockTestimonials = [
  {
    name: "Priya S",
    designation: "Sales Manager",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
  {
    name: "John D",
    designation: "Marketing Lead",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
  {
    name: "Sara K",
    designation: "Operations Head",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
  {
    name: "Michael B",
    designation: "Founder & CEO",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
  {
    name: "Linda C",
    designation: "Customer Support",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
  {
    name: "Amit P",
    designation: "Business Analyst",
    message:
      "We’ve tried a few CRMs before, but Manage360 just clicked. The dashboard is super intuitive, and honestly, we’ve saved hours every week just by streamlining our follow-ups.",
    image: UserImg,
  },
];

const Constumers = () => {
  return (
    <Box className="testimonialSecMain">
      <Image
        src={VidSecBg}
        height="100%"
        className="videSecBg"
        width="100%"
        alt=""
      />
      <Container maxW="container.xl">
        <Box className="customersSection">
          <Box className="sectionTitlebox">
            <Text className="iconSubtitle">
              <Image src={SubtitleIcon} height="16px" width="16px" alt="" /> {landingPageConstants.ourCustomers}
            </Text>
            <Text className="sectionTitle">{landingPageConstants.customersDesc}</Text>
          </Box>
          <Grid templateColumns="repeat(6, 1fr)" gap="24px" mt={{base: "32px", md: "52px", lg: "64px"}}>
            {mockTestimonials.map((testimonial, index) => (
              <GridItem colSpan={{base:6, md:3, lg:2}} key={index}>
                <Box className="testimonialBox">
                  <Box>
                    <Text className="testimonialTitle">{testimonial.name}</Text>
                    <Text className="testimonialDesc">
                      “{testimonial.message}”
                    </Text>
                  </Box>
                  <Box display="flex" gap="16px" alignItems="center" mt="24px">
                    <Box minWidth="52px">
                      <Image
                        src={testimonial.image}
                        height="52px"
                        width="52px"
                        borderRadius="50%"
                        objectFit="cover"
                        alt={testimonial.name}
                      />
                    </Box>
                    <Box className="testimonialUserInfo">
                      <Text className="testimonialUserName">
                        {testimonial.name}
                      </Text>
                      <Text className="testimonialUserDesignation">
                        {testimonial.designation}
                      </Text>
                    </Box>
                  </Box>
                </Box>
              </GridItem>
            ))}
          </Grid>
        </Box>
        <Box display={"flex"} className="lightbgCustomerBtn" justifyContent={"center"} mt={"20px"}>
          <Button colorScheme="brand" className="customButton landingButtons" height={"52px"}>
            {landingPageConstants.seeMoreTestimonials}
            <Image
                        src={ArrowRight}
                        height="24px"
                        width="24px"
                        marginLeft="8px"
                        alt="" 
                        />
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Constumers;
